const initialiseBallot = () => {
  const ballot = document.querySelector('[data-ballot-form]');

  if (!ballot || ballot.dataset.initialised === 'true') {
    return;
  }

  const offices = JSON.parse(ballot.dataset.offices || '[]');
  const form = ballot.querySelector('form');

  if (!form) {
    return;
  }

  offices.forEach((office) => {
    const choiceInputs = Array.from(form.querySelectorAll(`[name="fields[${office.handle}]"]`));
    const writeIn = form.querySelector(`[name="fields[${office.handle}WriteIn]"]`);
    const candidate = form.querySelector(`.ballot-candidate[data-office="${office.handle}"]`);

    if (!choiceInputs.length || !writeIn || !candidate) {
      return;
    }

    const choiceField = choiceInputs[0].closest('[data-field-config]')?.parentElement;
    const writeInField = writeIn.closest('[data-field-config]')?.parentElement;
    const candidateField = candidate.closest('[data-field-config]')?.parentElement;
    const candidateNameElement = candidate.querySelector('h2, strong');
    const candidateName = candidateNameElement?.textContent?.trim() || 'Listed nominee';

    if (!choiceField || !writeInField || !candidateField) {
      return;
    }

    const officeCard = document.createElement('fieldset');
    officeCard.className = 'ballot-office';
    officeCard.innerHTML = `
      <legend class="ballot-office__heading">
        <span class="ballot-office__title">${candidate.dataset.title || office.title || ''}</span>
        <span class="ballot-office__term">Term: ${candidate.dataset.term || office.term || ''}</span>
      </legend>
      <div class="ballot-office__body">
        <div class="ballot-office__candidate"></div>
      </div>
    `;

    candidateField.before(officeCard);
    const candidateContainer = officeCard.querySelector('.ballot-office__candidate');
    const choices = document.createElement('div');
    choices.className = 'ballot-office__choices';
    candidateContainer.append(candidateField);
    candidate.after(choices);
    choices.append(choiceField, writeInField);

    const nomineeLabel = choiceField.querySelector('input[value="nominee"]')?.closest('label');
    const writeInLabel = choiceField.querySelector('input[value="writeIn"]')?.closest('label');

    if (nomineeLabel) {
      const labelText = nomineeLabel.querySelector('.label') || nomineeLabel.lastChild;
      if (labelText) {
        labelText.textContent = candidateName;
      }
      nomineeLabel.classList.add('ballot-office__nominee');
    }

    if (writeInLabel) {
      writeInLabel.classList.add('ballot-office__write-in-choice');
    }

    writeIn.placeholder = 'Enter candidate’s full name';
    writeIn.setAttribute('autocomplete', 'off');
  });

  const submit = form.querySelector('button[type="submit"], input[type="submit"]');
  if (submit) {
    if (submit.tagName === 'INPUT') {
      submit.value = 'Cast Vote';
    } else {
      submit.textContent = 'Cast Vote';
    }
  }

  ballot.dataset.initialised = 'true';
};

document.addEventListener('DOMContentLoaded', initialiseBallot);
document.addEventListener('onFormieInit', initialiseBallot);
